<template>
  <v-dialog v-model="dialog" persistent width="980px">
    <v-card>
      <v-card-title class="headline ma-0">
        <v-icon>remove_red_eye</v-icon> Ver seguimiento solicitud con cargo a
        vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-3">
        <v-container class="p-0" grid-list-md style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <h4 class="texto">
                <strong>Número:</strong> {{ permiso.numero }}
              </h4>
            </v-flex>
            <v-flex xs12>
              <h4 class="texto">
                <strong>Nombre:</strong> {{ permiso.nombres }}
              </h4>
            </v-flex>
          </v-layout>
          <h4 class="subtitulo-uso"><strong>Detalle de vacación </strong></h4>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light celda-comprimida"
                :items="permiso_detalles"
                hide-actions
                :headers="headers"
                v-if="permiso.permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td
                    class="text-xs-center"
                    v-if="permiso.permiso.id_tipo_permiso == '24'"
                  >
                    {{ props.item.fecha_desde }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="permiso.permiso.id_tipo_permiso == '24'"
                  >
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ permiso.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <h4 class="subtitulo-uso">
            <strong>Seguimiento solicitud con cargo a vacación</strong>
          </h4>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light celda-comprimida"
                :items="detalle_seguimiento"
                hide-actions
                :headers="headers_detalle"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      props.item.id_estado == 75
                        ? "Aprobado"
                        : props.item.estado
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.usuario }}</td>
                  <td class="text-xs-center">{{ props.item.motivo }}</td>
                  <td class="text-xs-center">{{ props.item.jefe }}</td>
                  <td class="text-xs-center">
                    <v-tooltip bottom>
                      <v-btn
                        v-if="!!props.item.ruta_archivo"
                        color="primary"
                        @click.prevent="verArchivo(props.item)"
                        icon
                        dark
                        slot="activator"
                        ><v-icon>attach_file</v-icon>
                      </v-btn>
                      <span>Ver archivo adjunto</span>
                    </v-tooltip>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <!-- <v-spacer></v-spacer>
        <v-btn type="submit" @click.prevent="close()"
          ><v-icon>clear</v-icon>
          Cerrar
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  components: {},
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogVerPermiso", async item => {
      this.permiso = item;
      await this.getDetallePermiso(item.id_permiso);
      this.getDetalleSeguimiemto(item.id_permiso);
      this.dialog = true;
    });
  },
  data() {
    return {
      usuario: this.$storage.get("user"),
      dialog: false,
      permiso: {
        permiso: {
          motivo: ""
        }
      },
      permiso_compensacion: [],
      permiso_detalles: [],
      permiso_detalles2: [],
      permiso_detalle: [],
      motivo2: [],
      vDetallePermisos: {},

      loading: false,
      headers: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Días",
          sortable: false,
          align: "center"
        }
      ],

      horas_solicitadas: 0,
      horas_solicitadas_comp: 0,
      detalle_seguimiento: [],
      headers_detalle: [
        {
          text: "Fecha de registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        },
        {
          text: "Justificación",
          sortable: false,
          align: "center"
        },
        {
          text: "Solicitud enviada a:",
          sortable: false,
          align: "center"
        },
        {
          text: "Acciones",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
    },
    // Metodo para ver el archivo adjunto
    verArchivo(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$query.select("v_seguimiento_detalle", { id: id }, [
          "fecha_registro",
          "estado",
          "usuario",
          "jefe",
          "id_estado",
          "motivo",
          "jefe",
          "ruta_archivo"
        ]);
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },

    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
			query{
              vDetallePermisos(lista_estados:"22,9,6,7,16,21,75",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
				  total_dias
				  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        // this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>
<style scoped>
.titulo {
  font-size: 1.07em;
  color: rgb(0, 77, 128);
  font-weight: bold;
  margin: 0 !important;
}
.texto {
  font-size: 1.07em;
  color: rgb(0, 50, 83);
  margin: 0 !important;
}
.subtitulo-uso {
  font-size: 1.35em;
  color: rgb(0, 77, 128);
  font-weight: bolder;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/VerPermiso.vue